import withAvailableFilters from '../../components/ListFilters/withAvailableFilters';
import Apps from './Apps';
import Vendors from './Vendors';

const AppsWithFilters = withAvailableFilters(Apps);
const VendorsWithFilters = withAvailableFilters(Vendors);
export { AppsWithFilters as Apps, VendorsWithFilters as Vendors };
